

const RequestADemoDialog = ({ onSubmit, closeDialog, setFormData, formData, setErrors, errors }) => {


    
  const phoneRegex = /^\d{10}$/;
  const fakeNumbers = ["0000000000", "9999999999", "1234567890"];
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i;

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));

    // Clear error when valid input
    if (name === "email" && emailRegex.test(value)) {
      setErrors((prev) => ({ ...prev, email: "" }));
    }

    if (name === "contact" && phoneRegex.test(value)) {
      setErrors((prev) => ({ ...prev, contact: "" }));
    }
  };
  return (
    <div style={{ backgroundColor: "red", margin: -25 }}>
      <div className="card shadow">
        {/* Header */}
        <div
          className="card-header d-flex justify-content-between align-items-center"
          style={{ backgroundColor: "#b63266" }}
        >
          <h4 className="mb-0 mt-2" style={{ color: "white" }}>
            Request A Demo
          </h4>
          <button
            className="mt-2"
            type="button"
            onClick={() => closeDialog()} // <-- make sure to define or pass this prop
            aria-label="Close"
            style={{
              color: "white",
              background: "transparent",
              border: "none",
              fontSize: "1.25rem",
              cursor: "pointer",
            }}
          >
            <i className="fa fa-times" aria-hidden="true"></i>
            <span className="sr-only">Close</span>
          </button>
        </div>

        {/* Body */}
        <div className="card-body">
          <form onSubmit={onSubmit}>
            <div className="form-group row mb-3">
              <div className="col-sm-6">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={handleChange}
                  value={formData.name}
                  name="name"
                  placeholder="Enter name"
                  required
                />
              </div>
              <div className="col-sm-6">
                <label htmlFor="email">Email address</label>
                <input
                  type="email"
                  className="form-control"
                  onChange={handleChange}
                  name="email"
                  value={formData.email}
                  placeholder="Enter email"
                  required
                />
                {errors.email && (
                  <div className="error">{errors.email}</div>
                )}
              </div>
            </div>

            <div className="form-group row mb-3">
              <div className="col-sm-6">
                <label htmlFor="contact">Mobile No.</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={handleChange}
                  value={formData.contact}
                  name="contact"
                  placeholder="Enter mobile"
                  required
                />
                {errors.contact && (
                  <div className="error">{errors.contact}</div>
                )}
              </div>
              <div className="col-sm-6">
                <label htmlFor="businessname">Business Name</label>
                <input
                  type="text"
                  className="form-control"
                  onChange={handleChange}
                  value={formData.businessname}
                  name="businessname"
                  placeholder="Enter business name"
                  required
                />
              </div>
            </div>

            <div className="form-group mb-3">
              <label>Preferred Mode Of Call :</label>
              <div className="d-flex flex-wrap mt-2">
                {["Skype", "Zoom", "WhatsApp", "Google Meet", "MS Teams"].map(
                  (mode) => (
                    <div className="form-check me-3" key={mode}>
                      <input
                        className="form-check-input"
                        type="radio"
                        name="preferredmode"
                        value={mode}
                        checked={formData.preferredmode === mode}
                        onChange={handleChange}
                        id={mode}
                      />
                      <label className="form-check-label" htmlFor={mode}>
                        {mode}
                      </label>
                    </div>
                  )
                )}
                {errors.preferredmode && (
                  <div className="error">{errors.preferredmode}</div>
                )}
              </div>
            </div>

            <div className="form-group mb-3">
              <label htmlFor="message">Message</label>
              <textarea
                className="form-control"
                name="message"
                rows="4"
                onChange={handleChange}
                value={formData.message}
                placeholder="Enter your message...."
                required
              ></textarea>
            </div>

            <div className="text-center">
              <button
                type="submit"
                className="btn"
                style={{
                  backgroundColor: "#b63266",
                  color: "white",
                  border: "none",
                }}
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
     
    </div>
  );
};

export default RequestADemoDialog;
